import clsx from "clsx";
import React from "react";

function Version({ className, short = false }) {
    return (
        <div className={clsx("version", className)}>
            <span className="font-small text--grey">
                {short ? "v" : "Version "}
                {__APP_VERSION__}
            </span>
        </div>
    );
}

export default Version;
